import { ref, onMounted, onUnmounted, computed } from "vue";

export default function () {
    const windowWidth = ref(window.innerWidth);

    const onWidthChange = () => {
        windowWidth.value = window.innerWidth;
    }

    const isMobile = computed(() => windowWidth.value < 640) // xs
    const isTablet = computed(() => windowWidth.value < 768)
    const sm = computed(() => windowWidth.value >= 640 && windowWidth.value < 768)
    const md = computed(() => windowWidth.value >= 768 && windowWidth.value < 1024)
    const isDesktop = computed(() => windowWidth.value >= 1024) //lg

    onMounted(() => {
        window.addEventListener('resize', onWidthChange);
    });

    onUnmounted(() => {
        window.removeEventListener("resize", onWidthChange);
    })

    return {
        windowWidth,
        onWidthChange,
        sm,
        md,
        isMobile,
        isTablet,
        isDesktop,
    }
}